import { gql } from 'apollo-boost';

export const deletePortfolioMutation = gql`
  mutation deletePortfolioMutation($id: Int!) {
    deletePortfolio(id: $id) {
      success
    }
}`;
